<div id="tables-plan" [class]="(tablesPlanFontSize | fontSizeClass)">
    
    <div id="main-container">
        <div id="topbar-container">
            <app-topbar></app-topbar>
        </div>

        <div id="inner-container">
            <div id="sidepanel" [class.collapsed]="sidePanelCollapsed">
                @if (editMode) {
                    <app-toolbox></app-toolbox>
                } @else {
                    <app-sidepanel></app-sidepanel>
                }
            </div>

            <div id="canvas-container" [class.side-panel-collapsed]="sidePanelCollapsed">
                <app-canvas></app-canvas>
            </div>
        </div>
    </div>
    
</div>